import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

import { DEPART_DIRECTION } from '../../../../constants';

function sortInfoHovered({
    batchId,
    direction,
    totalTrips,
}) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'hover',
        category: 'react_search',
        label: 'sort_by_info',
    });

    amplitude.track('search_interacted', {
        batch_id: batchId,
        interaction_type: 'hovered_sort_by_info',
        is_departing_results: direction === DEPART_DIRECTION,
        results_count: totalTrips,
    });
}

export default { sortInfoHovered };
